export default [
  { source: 'Oscar Wilde', text: 'Seja você mesmo. Todos as outras pessoas já são alguém.' },
  { source: 'Oscar Wilde', text: 'Sempre perdoe seus inimigos. Nada os irrita mais que isso.' },
  {
    source: 'Virginia Satir',
    text: 'Não devemos permitir que as perceções limitadas dos outros nos definam.'
  },
  { source: 'William Shakespeare', text: 'Isso acima de tudo: seja verdadeiro consigo mesmo.' },
  {
    source: 'Helen Keller',
    text: 'Caminhar com um amigo no escuro é melhor que caminhar sozinho na luz.'
  },
  {
    source: 'Winston Churchill',
    text:
      'É preciso coragem para levantar e falar. Também é preciso coragem para sentar e se calar.'
  },
  {
    source: 'Martin Luther King, Jr.',
    text: 'O perdão não é um ato ocasional; é uma atitude constante.'
  },
  { source: 'J.R.R. Tolkien', text: 'Encontramos coragem nos lugares menos prováveis.' },
  { source: 'J.R.R. Tolkien', text: 'Onde há vida, há esperança.' },
  {
    source: 'J.R.R. Tolkien',
    text: 'Não é a força do corpo que conta, mas a força do espírito.'
  },
  {
    source: 'Dr. Seuss',
    text:
      'Seja quem você é e diga o que sente, pois quem se importa não importa e quem importa não se importa.'
  },
  {
    source: 'Stephen King',
    text:
      'É impossível negar a risada; quando ela chega, se esparrama na sua cadeira favorita e fica lá o quanto quiser.'
  },
  {
    source: 'Abraham Lincoln',
    text: 'Ninguém tem uma memória boa o suficiente para ser um mentiroso bem-sucedido.'
  },
  { source: 'Mark Twain', text: 'Todas as generalizações são falsas, incluindo essa aqui.' },
  { source: 'Ronald Reagan', text: 'Uma imagem vale 1.000 contradições.' },
  {
    source: 'Eleanor Roosevelt',
    text:
      'Grandes mentes discutem ideias; mentes médias discutem eventos; mentes pequenas discutem pessoas.'
  },
  {
    source: 'J.K. Rowling',
    text: 'Nossas escolhas mostram quem somos, muito mais do que nossas habilidades.'
  },
  {
    source: 'Dax Shephard',
    text:
      'Sucesso é apenas uma guerra de atrito. Claro que há um aspecto de talento que você provavelmente deveria ter. Mas se você aguentar as pontas por tempo suficiente, eventualmente algo vai acontecer.'
  },
  {
    source: 'Katherine Hepburn',
    text: 'Se você sempre faz o que te interessa, pelo menos uma pessoa vai estar contente.'
  },
  {
    source: 'Audrey Hepburn',
    text: 'Tudo é possível, a expressão em si diz “tudo”.'
  },
  {
    source: 'Wilma Rudolph',
    text:
      'Nunca subestime o poder dos sonhos e a influência do espírito humano. Somos todos iguais neste conceito: o potencial para a grandeza existe em todos nós.'
  },
  {
    source: 'Francois de La Rochefoucauld',
    text: 'Para alcançar a grandiosidade é preciso viver como se nunca fôssemos morrer.'
  },
  {
    source: 'Edmund Hillary',
    text:
      'As pessoas não decidem se tornar extraordinárias. Elas decidem realizar coisas extraordinárias.'
  },
  {
    source: 'Albert Einstein',
    text: 'Quem nunca errou, nunca tentou algo novo.'
  },
  {
    source: 'Jimmy Dean',
    text:
      'Não posso mudar a direção do vento, mas posso ajustar as velas do meu barco para sempre chegar ao meu destino.'
  },
  {
    source: 'Nelson Mandela',
    text: 'Um vencedor é um sonhador que nunca desiste.'
  },
  {
    source: 'Eleanor Roosevelt',
    text: 'Ninguém pode fazer com que você se sinta inferior sem a sua permissão.'
  },
  {
    source: 'Henry Ford',
    text: 'Se você pensa que é capaz ou se pensa que não é capaz, você está correto.'
  },
  {
    source: 'Alice Walker',
    text: 'A forma mais comum de perder seu poder é acreditar que você não tem nenhum.'
  },
  {
    source: 'Oprah Winfrey',
    text:
      'Seja grato pelo que você tem, você terá mais. Se você se concentrar no que não tem, jamais terá o suficiente.'
  },
  {
    source: 'Hellen Keller',
    text:
      'Quando uma porta se fecha, outra abre, mas geralmente olhamos tanto para a porta fechada que não vemos a nova que se abriu.'
  },
  {
    source: 'George Addair',
    text: 'Tudo que você sempre quis está do outro lado do medo.'
  },
  {
    source: 'Amelia Earhart',
    text: 'O mais difícil é a decisão de agir, o restante é só persistência.'
  },
  {
    source: 'George Whitefield',
    text:
      'Continue adiante. Não pare, não hesite em sua jornada, se esforce em direção à meta a sua frente.'
  },
  {
    source: 'Charles Swindoll',
    text: 'A vida é 10% o que acontece comigo e 90% como eu reajo.'
  },
  {
    source: 'Michael Phelps',
    text:
      'Haverá obstáculos. Pessoas vão duvidar. Haverá erros. Mas com trabalho duro, não há limites.'
  },
  {
    source: 'Babe Ruth',
    text: 'É simplesmente impossível vencer alguém que nunca desiste.'
  },
  {
    source: 'Thomas Edison',
    text:
      'Muitos dos fracassos na vida são de pessoas que não se deram conta o quão perto estavam do sucesso quando desistiram.'
  },
  {
    source: 'Aristotle Onassis',
    text: 'Em nossos momentos mais sombrios é que devemos nos concentrar mais para ver a luz.'
  },
  {
    source: 'Eleanor Roosevelt',
    text: 'Com o novo dia vêm nova força e novas ideias.'
  },
  {
    source: 'Robert Louis Stevenson',
    text: 'Não julgue cada dia pela colheita que obteve, mas pelas sementes que você plantou.'
  },
  {
    source: 'Vincent Van Gogh',
    text:
      'Se ouvir uma voz dentro de você dizendo “não desenhe”, então faça o possível para desenhar, e essa voz será silenciada.'
  },
  {
    source: 'Roy T. Bennett',
    text: 'Não seja pressionado pelos medos em sua mente. Seja guiado pelos sonhos em seu coração.'
  },
  {
    source: 'Mark Cuban',
    text:
      'Sempre acorde com um sorriso, sabendo que hoje você vai se divertir realizando coisas que outras pessoas têm medo de fazer.'
  },
  {
    source: 'Maya Angelou',
    text: 'Se você não gosta de algo, mude-o. Se não pode mudá-lo, mude a sua atitude.'
  },
  {
    source: 'Jesse Owens',
    text:
      'Encontre o bem. Ele está ao seu redor. Encontre-o, mostre-o e você vai começar a acreditar nele.'
  },
  {
    source: 'Audre Lorde',
    text:
      'Se eu não me definir como eu mesmo, vou ser esmagado e engolido pelas fantasias das outras pessoas sobre mim.'
  },
  {
    source: 'Viola Davis',
    text:
      'Não tenho tempo para passar a noite inteira me preocupando com o que alguém que não me ama tem a dizer sobre mim.'
  },
  {
    source: 'Frederick Douglass',
    text:
      'Rezei por vinte anos mas nunca obtive resposta até que comecei a rezar com minhas pernas.'
  },
  {
    source: 'Barack Obama ',
    text:
      'A mudança não vem se a esperamos de outra pessoa, ou se esperamos por outro momento. Nós somos as pessoas por quem estávamos esperando. Nós somos a mudança que buscamos.'
  },
  {
    source: 'James Baldwin',
    text:
      'Nunca haverá um tempo no futuro onde descobrimos nossa salvação. O desafio está no momento, o momento é sempre agora.'
  },
  {
    source: 'Dr. Martin Luther King, Jr.',
    text:
      'Se não pode voar, então corra; se não pode correr, então ande; se não pode andar, então engatinhe; mas aconteça o que acontecer, continue se movendo adiante.'
  },
  {
    source: 'Dr. Mae Jamison',
    text: 'Nunca deixe a imaginação limitada dos outros te limitar.'
  },
  {
    source: 'Phylicia Rashad',
    text:
      'Sempre existe algo sugerindo que você nunca vai ser quem você quer ser. Sua escolha é aceitar ou continuar caminhando.'
  },
  {
    source: 'Beyoncé Knowles',
    text: 'O poder não é dado a você. É preciso conquistá-lo.'
  },
  {
    source: 'Arthur Ashe',
    text:
      'Uma chave importante para o sucesso é a auto-confiança. Uma chave importante para a auto-confiança é o preparo.'
  },
  {
    source: 'Frank Sinatra',
    text: 'A melhor vingança é um enorme sucesso.'
  },
  {
    source: 'J.K. Rowling',
    text:
      'Acorda sempre com um sorriso sabendo que hoje te vais divertir, fazendo o que os outros têm medo de fazer.'
  },
  {
    source: 'Steve Jobs',
    text: 'Seu tempo é limitado, então não o desperdice vivendo a vida de outra pessoa.'
  },
  {
    source: 'Zig Ziglar',
    text:
      'Dizem que a motivação não dura. Bem, o banho também não. Por isso recomendamos tomar diariamente.'
  },
  {
    source: 'Jim Rohn',
    text: 'Você é uma média das cinco pessoas com quem passa mais tempo.'
  },
  {
    source: 'Vince Lombardi',
    text:
      'A diferença entre uma pessoa bem-sucedida e outras não é falta de força, nem falta de conhecimento, mas sim a falta de vontade.'
  },
  {
    source: 'Bruce Lee',
    text: 'Se você ama a vida, não perca tempo, pois é de tempo que a vida é feita.'
  },
  {
    source: 'Abraham Lincoln',
    text: 'As coisas podem vir para quem espera, mas só o que sobrou de quem trabalha.'
  },
  {
    source: 'John Lennon',
    text: 'Vida é o que acontece enquanto você está ocupado fazendo planos.'
  },
  {
    source: 'Angelica Monroy',
    text: 'Abrace suas vulnerabilidades, aceite-as e perdoe a si mesmo.'
  },
  {
    source: 'Iris Soto',
    text:
      'Ao enfrentar desafios difíceis lembre-se que eles são bênçãos disfarçadas, encare-os com fé.'
  },
  {
    source: 'Carlos Santana',
    text:
      'O bem mais valioso que você pode ter é um coração aberto. A arma mais poderosa que você pode ser é um instrumento de paz.'
  },
  {
    source: 'Cesar Chavez ',
    text: 'A preservação de uma cultura não requer desprezo ou desrespeito a outras culturas.'
  },
  {
    source: 'Gwendolyn Brooks',
    text:
      'Não deixe ninguém te chamar de minoria se você é negro ou hispânico, ou pertence a algum outro grupo étnico. Você não é menor que ninguém.'
  },
  {
    source: 'Dolly Parton ',
    text: 'Do jeito que vejo, se você quer um arco-íris, precisa aguentar a chuva.'
  },
  {
    source: 'Dr. Seuss',
    text:
      'Em algumas situações você nunca saberá o valor de um momento até que ele se torne memória.'
  },
  {
    source: 'C.S. Lewis',
    text: 'Você nunca é velho demais para ter um novo objetivo ou sonhar um novo sonho.'
  },
  {
    source: 'Helen Keller',
    text: 'Nunca abaixe a cabeça. Sempre a mantenha alta. Olhe o mundo diretamente nos olhos.'
  },
  {
    source: 'Theodore Roosevelt',
    text: 'Acredite que você é capaz e metade do caminho terá sido percorrido.'
  },
  {
    source: 'Carol Burnett',
    text: 'Quando você tem um sonho, agarre-o e não o solte.'
  },
  {
    source: 'Albert Einstein',
    text:
      'A vida é como andar de bicicleta. Para manter o equilíbrio é preciso continuar em movimento.'
  },
  {
    source: 'Ella Fitzgerald',
    text:
      'Não desista de tentar fazer o que você realmente quer fazer. Onde há amor e inspiração, não creio que seja possível errar.'
  },
  {
    source: 'Amy Poehler',
    text: 'Limite seus “sempres” e seus “nuncas”.'
  },
  {
    source: 'Maya Angelou',
    text: 'Se você está sempre tentando ser normal nunca vai saber o quão incrível você pode ser.'
  },
  {
    source: '"Camilla Eyring Kimball',
    text: 'Não se descobre a vida feliz. Você a constrói.'
  },
  {
    source: 'E.E. Cummings',
    text: 'Os dias mais desperdiçados são aqueles sem risadas.'
  },
  {
    source: 'George Eliot',
    text: 'Nunca é tarde demais para ser o que você poderia ter sido.'
  },
  {
    source: 'Hazrat Inayat Khan',
    text: 'Alguns procuram por um lugar bonito. Outros fazem um lugar bonito.'
  },
  {
    source: 'Lindsey Von',
    text: 'A vida muda rapidamente, de maneira muito positiva, se você permitir.'
  },
  {
    source: 'Malala Yousafzai',
    text: 'Vamos fazer nosso futuro agora, e fazer dos nossos sonhos a realidade de amanhã.'
  },
  {
    source: 'Mandy Hale',
    text:
      'Você nem sempre precisa de um plano. Às vezes basta respirar, confiar, desapegar, e ver o que acontece.'
  },
  {
    source: 'Meghan Markle',
    text: 'Você é o suficiente sendo do jeito que é.'
  },
  {
    source: 'Martin Luther King Jr.',
    text: 'Se não posso fazer coisas grandiosas, posso fazer coisas pequenas de maneira grandiosa.'
  },
  {
    source: 'Nicole Kidman',
    text: 'A vida é cheia de voltas e curvas. Segure firme e vamos lá.'
  },
  {
    source: 'Oprah Winfrey',
    text: 'Se olhares bem para o que tens na tua vida, terás sempre mais.'
  },
  {
    source: 'Reese Witherspoon',
    text: 'Com o tipo certo de treinamento e determinação, você pode realizar qualquer coisa.'
  },
  {
    source: 'Roald Dahl',
    text:
      'Se você tem bons pensamentos eles irão brilhar no seu rosto como raios de sol e você sempre parecerá adorável.'
  },
  {
    source: 'Robin Williams',
    text: 'Não importa o que te digam, palavras e ideias podem mudar o mundo.'
  },
  {
    source: 'Rosa Parks',
    text: 'Cada pessoa deve viver sua vida como um modelo para as outras.'
  },
  {
    source: 'Serena Williams',
    text: 'Um campeão não é definido por suas vitórias, mas por como se recupera depois de falhar.'
  },
  {
    source: 'Sheryl Sandberg',
    text: 'Motivação vem ao trabalhar em coisas com as quais nos importamos.'
  },
  {
    source: 'Walt Whitman',
    text: 'Mantenha seu rosto sempre em direção ao sol, a sombras ficarão para trás.'
  },
  {
    source: 'John Bunyan',
    text:
      'Você ainda não viveu o dia de hoje até que faça algo para alguém que jamais pode te recompensar.'
  },
  {
    source: 'Walt Whitman',
    text: 'Cada momento de luz e trevas é um milagre.'
  },
  {
    source: 'Will Rogers',
    text: 'Mesmo se estiver na pista certa, você vai ser atropelado se ficar parado.'
  },
  {
    source: 'Mark Zuckerberg',
    text:
      'O maior risco é não assumir nenhum risco. Em um mundo que muda tão rápido, a única estratégia com garantia de fracasso é não assumir riscos.'
  },
  {
    source: 'Napolean Hill',
    text: 'O que a mente pode conceber, ela pode realizar.'
  },
  {
    source: 'Ted Murphy',
    text: 'Se não te assusta um pouco, provavelmente não merece seu tempo.'
  },
  {
    source: 'Sydney Harris',
    text: 'Quando ouço “A vida é dura”, sempre quero perguntar: “Comparado ao quê?”'
  },
  {
    source: 'Arthur Schopenhauer',
    text:
      'Toda verdade passa por três estágios antes de ser reconhecida. No primeiro, é ridicularizada. No segundo, é oposta. No terceiro é considerada claramente evidente.'
  },
  {
    source: 'John F. Kennedy',
    text: 'Se não nós, quem? Se não agora, quando?'
  },
  {
    source: 'Jack Canfield ',
    text:
      'Não se preocupe com fracassos. Se preocupe com as chances que perde quando nem sequer tenta.'
  },
  {
    source: 'Sir Claus Moser',
    text: 'Educação custa dinheiro. E ignorância também.'
  },
  {
    source: 'John Wooden',
    text: 'Não deixe o que você não pode fazer interferir com o que você pode fazer.'
  },
  {
    source: 'Babe Ruth',
    text: 'Cada chute me leva mais perto do gol.'
  },
  {
    source: 'Dr. Martin Luther King Jr.',
    text: 'O fim das nossas vidas começa no dia em que nos calamos sobre as coisas que importam.'
  },
  {
    source: 'Maya Angelou',
    text:
      'Preconceito é um fardo que confunde o passado, ameaça o futuro e torna o presente inacessível.'
  },
  {
    source: 'Rosa Parks',
    text:
      'Para trazer mudança, é preciso não temer o primeiro passo. Fracassamos quando não tentamos.'
  },
  {
    source: 'James Baldwin',
    text: 'Nem tudo que se enfrenta pode ser mudado, mas nada pode ser mudado até ser enfrentado.'
  },
  {
    source: 'Dr. Martin Luther King Jr.',
    text:
      'Escuridão não expulsa escuridão, só a luz faz isso. Ódio não expulsa ódio, só o amor faz isso.'
  },
  {
    source: 'Malcolm X',
    text: 'Alguém que não acredita em nada, pode ser enganado por tudo.'
  },
  {
    source: 'Dr. Cornel West',
    text: 'Justiça é amor em público.'
  },
  {
    source: 'Malcolm X',
    text:
      'Não se pode separar a paz da liberdade, pois ninguém pode estar em paz a menos que tenha sua liberdade.'
  },
  {
    source: 'Andrew Hendrixson',
    text: 'Qualquer pessoa que tenha feito algo importante foi disciplinada.'
  },
  {
    source: 'Coco Chanel',
    text: 'Não perca tempo batendo contra uma parede na esperança de que ela se torne uma porta.'
  },
  {
    source: 'Albert Einstein',
    text: 'Criatividade é a inteligência se divertindo.'
  },
  {
    source: 'Grace Coddington',
    text:
      'Sempre mantenha seus olhos abertos. Continue observando. Pois tudo que você vê pode te inspirar.'
  },
  {
    source: 'Henry David Thoreau',
    text:
      'O que você obtém ao atingir seus objetivos não é tão importante quanto o que você se torna ao atingir seus objetivos.'
  },
  {
    source: 'Seth Godin',
    text:
      'Ao invés de imaginar quando serão suas próximas ferias, talvez você deva criar uma vida da qual não precise escapar.'
  },
  {
    source: 'John Maxwell',
    text: 'Às vezes você ganha, às vezes você aprende.'
  },
  {
    source: 'Audre Lorde',
    text:
      'Cuidar de mim mesmo não é comodismo, é autopreservação; e isso é um ato de guerra política.'
  },
  {
    source: 'Assata Shakur',
    text: 'Sonhos e realidade são opostos. A ação os sintetiza.'
  },
  {
    source: 'Wangari Maathai',
    text: 'Há oportunidades até nos momentos mais difíceis.'
  },
  {
    source: 'Rev. Peter Marshall',
    text:
      'Que possamos pensar na liberdade, não como o direito de fazer o que quisermos, mas como a oportunidade de fazer o que é certo.'
  },
  {
    source: 'Martha Grimes',
    text: 'Não sabemos quem somos até percebermos do que somos capazes.'
  },
  {
    source: 'Vidal Sassoon ',
    text: 'Ouça bons conselhos, tenha certeza de que são bons conselhos e depois faço do seu jeito.'
  },
  {
    source: 'Adelaide Anne Procter',
    text: 'Sempre podemos ser o que poderíamos ter sido.'
  },
  {
    source: 'George Patton',
    text:
      'Nunca diga às pessoas como fazer as coisas. Diga o que fazer e elas irão te surpreender com suas engenhosidades.'
  },
  {
    source: 'Robert Frost ',
    text: 'Muitas das mudanças que vemos na vida se devem a verdades entrando e saindo de moda.'
  },
  {
    source: 'Bob Black',
    text:
      'Você é o que faz. Se você faz um trabalho chato, estúpido e monótono, as chances são de que você se tornará chato, estúpido e monótono.'
  },
  {
    source: 'Georg Wilhelm Friedrich Hegel',
    text: 'Nada de grandioso no mundo foi realizado sem paixão.'
  },
  {
    source: 'Robert Louis Stevenson',
    text: 'Não julgue cada dia pela colheita que obteve, mas pelas sementes que você plantou.'
  },
  {
    source: 'Friedrich Nietzsche',
    text:
      'Há um único caminho no mundo que ninguém além de você pode trilhar: para onde ele leva? Não pergunte, caminhe.'
  },
  {
    source: 'Pablo Picasso ',
    text: 'Arte é uma mentira que nos faz perceber a verdade.'
  },
  {
    source: 'Henry David Thoreau',
    text:
      'Quem avança com confiança na direção dos seus sonhos, e se empenha para viver a vida que imaginou, vai encontrar um sucesso inesperado em horas comuns.'
  },
  {
    source: 'Bob Dylan',
    text:
      'Não é do melhor interesse de ninguém pensar sobre como seremos vistos amanhã. Isso te prejudica a longo prazo.'
  },
  {
    source: 'Stephen Vincent Benet',
    text:
      'Não se perde a vida ao morrer! A vida se perde minuto após minuto, dia após dia que se arrastam, em todas as milhares de maneiras pequenas e indiferentes.'
  },
  {
    source: 'Mary Shelley',
    text: 'Nada é tão dolorido para a mente humana quanto uma mudança grande e abrupta.'
  },
  {
    source: 'E.M. Forster',
    text: 'Ou a vida implica em ter coragem, ou ela deixa de ser vida.'
  },
  {
    source: 'Ellen DeGeneres',
    text:
      'Aprendi sobre compaixão sofrendo discriminação. Tudo de ruim que já me aconteceu me ensinou compaixão.'
  },
  {
    source: 'James Cameron',
    text:
      'O fracasso tem que ser uma opção. ... Nenhum empreendimento importante que tenha precisado de inovação foi feito sem riscos.'
  },
  {
    source: 'Mandy Hale',
    text:
      'Tenha ousadia o suficiente para viver a vida em seus termos e nunca se desculpe por isso.'
  },
  {
    source: 'Debbi Fields',
    text: 'O maior fracasso na vida é nunca tentar.'
  },
  {
    source: 'Elizabeth Barrett Browning',
    text: 'Não meça sua produção até que o dia termine e o trabalho seja feito.'
  },
  {
    source: 'Ingvar Kamprad',
    text:
      'Cometer erros é o privilégio das pessoas ativas, ou daquelas que podem corrigir seus erros e reparar as coisas.'
  },
  {
    source: 'Leo Tolsto',
    ttext: 'Todo mundo pensa em mudar a humanidade e ninguém pensa em mudar a si mesmo.'
  },
  {
    source: 'Aldous Huxley',
    text: 'Só há um canto do universo que você certamente pode melhorar e é você mesmo.'
  },
  {
    source: 'Theodore Thornton Munger',
    text: 'Nada é mais comum do que homens de talento sem sucesso.'
  },
  {
    source: 'Steve Jobs',
    text:
      'Estou convencido de que metade do que separa os empreendedores bem-sucedidos daqueles sem sucesso é pura perseverança. É tão difícil.'
  },
  {
    source: 'Dwight D. Eisenhower',
    text: 'Planos são inúteis, mas planejar é tudo.'
  },
  {
    source: 'Booker T. Washington',
    text: 'Há duas maneiras de impor sua força: empurrando para baixo ou puxando para cima.'
  },
  {
    source: 'James Thurber',
    text:
      'Não olhemos para trás com raiva, nem para a frente com medo, mas sim ao redor com consciência.'
  },
  {
    source: 'Nelson Mandela',
    text: 'Que suas escolhas reflitam suas esperanças, não os seus medos.'
  },
  {
    source: 'Steve Jobs',
    text: 'As coisas não precisam mudar o mundo para serem importantes.'
  },
  {
    source: 'Albert Einstein',
    text:
      'A paz não pode ser mantida através da força ela só pode alcançada através da compreensão.'
  },
  {
    source: 'Frederick Douglass',
    text: 'A alma que existe em mim ninguém pode degradar.'
  },
  {
    source: 'Peter Drucker',
    text: 'A coisa mais importante na comunicação é ouvir o que não foi dito.'
  },
  {
    source: 'Molière',
    text: 'Pensar nas pessoas que amamos é um ótimo tempero para a felicidade.'
  },
  {
    source: 'William Feather',
    text: 'Quem está aproveitando a vida não fracassou.'
  },
  {
    source: 'Pablo Picasso',
    text: 'Aprenda as regras como um profissional, para poder quebrá-las como um artista.'
  },
  {
    source: 'Ursula Le Guin',
    text:
      'É bom ter um objetivo em direção ao qual caminhar, mas é a jornada que importa e não a chegada.'
  },
  {
    source: 'John F. Kennedy',
    text: 'A conformidade é carcereira da liberdade e inimiga do crescimento.'
  },
  {
    source: 'Robert Anthony',
    text: 'Algumas pessoas bebem na fonte da sabedoria. Outras apenas gargarejam.'
  },
  {
    source: 'Ralph Waldo Emerson',
    text: 'Todo artista foi primeiro um amador.'
  },
  {
    source: 'Samuel Butler',
    text: 'Todos os animais, exceto o homem, sabem que o objetivo principal da vida é aproveitá-la.'
  },
  {
    source: 'Bruce Lee',
    text: 'Absorva o que é útil. Descarte o que não é. Adicione o que é exclusivamente seu.'
  },
  {
    source: 'Earl Nightingale',
    text: 'Nos tornamos aquilo que pensamos.'
  },
  {
    source: 'Theodore Vail',
    text: 'Dificuldades reais podem ser superadas; apenas as imaginárias são invencíveis.'
  },
  {
    source: 'Washington Irving',
    text:
      'Mentes pequenas são domadas e subjugadas por infortúnios, mas as grandes mentes se elevam acima deles.'
  },
  {
    source: 'Arnold Bennett',
    text:
      'Qualquer mudança, mesmo para melhor, é sempre acompanhada de inconveniência e desconforto.'
  },
  {
    source: 'Dhirubhai Ambani',
    text:
      'Se você não construir os seus sonhos, alguém vai te contratar para ajudar na construção dos sonhos dele.'
  },
  {
    source: 'Mario Andretti',
    text: 'Se as coisas parecem sob controle, você simplesmente não está indo rápido o suficiente.'
  },
  {
    source: 'Oprah Winfrey',
    text:
      'Seja grato pelo que você tem, você terá mais. Se você se concentrar no que não tem, jamais terá o suficiente.'
  },
  {
    source: 'Helen Keller',
    text:
      'Evitar o perigo não é mais seguro a longo prazo do que a exposição direta. Os medrosos são pegos com a mesma frequência que os ousados.'
  },
  {
    source: 'Thomas Paine',
    text: 'Quanto mais difícil o conflito, mais glorioso é o triunfo.'
  },
  {
    source: 'Frank Tyger',
    text: 'Não há empréstimo maior do que um ouvido compreensivo.'
  },
  {
    source: 'Phyllis Theroux',
    text: 'Erros são as pontes habituais entre a inexperiência e a sabedoria.'
  },
  {
    source: 'Gaylord Nelson',
    text:
      'O teste definitivo da consciência de alguém pode ser sua disposição em sacrificar algo hoje em prol de futuras gerações cujo agradecimento não será ouvido.'
  },
  {
    source: 'Sarah Grand',
    text:
      'Nossa opinião sobre as pessoas depende menos do que vemos nelas, e mais do que elas nos fazem ver em nós mesmos.'
  },
  {
    source: 'George Santayana',
    text: 'Não há cura para o nascimento e a morte, a não ser aproveitar o intervalo no meio.'
  },
  {
    source: 'Margaret Chase Smith',
    text:
      'Quando continuam te dizendo que você não vai conseguir fazer algo, dá uma certa vontade de tentar.'
  },
  {
    source: 'André Gide',
    text: 'Acredite naqueles que buscam a verdade; duvide daqueles que a encontram.'
  },
  {
    source: 'Frank Yerby',
    text: 'Atingimos maturidade quando não precisamos mais que mintam para nós sobre nada.'
  },
  {
    source: 'Charles Dickens',
    text: 'Ninguém que alivia o fardo de outra pessoa é inútil nesse mundo.'
  },
  {
    source: 'Merry Browne',
    text:
      'Espere que as pessoas sejam melhores do que elas são; isso as ajuda a ser melhor. Mas não se decepcione se elas não forem, isso as ajuda a continuar tentando.'
  },
  {
    source: 'Doug Larson',
    text: 'Sabedoria é a qualidade que evita que você entre em situações onde pode precisar dela.'
  },
  {
    source: 'Laozi',
    text:
      'Para obter conhecimento, adicione mais coisas todo dia. Para obter sabedoria, remova coisas todo dia.'
  }
]
